import { Component, OnInit } from '@angular/core';
import { SalescartService } from 'src/app/services/salescart.service'
import { Clipboard } from '@angular/cdk/clipboard'
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss']
})
export class CouponComponent implements OnInit {
  couponList: Object;
  textMessageFunc: any;
  accountInformationType: any;

  constructor(
    private salesCartService: SalescartService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    private commonService: CommonService,
  ) { }

  configDataNew:any;

  ngOnInit(): void {

     const storedConfig = this.commonService.getConfigData();

    if (storedConfig) {
      this.configDataNew = JSON.parse(storedConfig);

      if(this.configDataNew!=null){
        this.getConfigData();
      }
     
    } else {
      console.warn('No config data found in localStorage.');
    }

    this.getCoupon();
  }

    getConfigData() {
      let data = this.configDataNew;
 
      this.accountInformationType = data['accountInformationType'];
  
  
    }

  getCoupon() {
    this.salesCartService.getSalesCart().subscribe(
      data => {
        this.couponList = data['content'];

      }
    )
  }


  copyInputMessage(i) {
    this.clipboard.copy(`${i}`);
    this.snackBar.open(`Coupon Code Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });

  }




}
